import React from "react";
import { NavLink } from "react-router-dom";
import Carousel from "../carousel/carousel";
import { urlparams } from "../../config/bootstrap";
import NativeShare from "../common/NativeShare";

class Mantra_3_A1_Share extends React.Component {
  render() {
    let { id, img, pageData } = this.props;
    let text = pageData.description ? pageData.description : "";

    return (
      <>
        {/* <Carousel /> */}
        <div className="m3_a1_container">
          <div className="container">
            <div className="m3_sh_img_prev">
              <span>Thank you for posting!</span>
            </div>

            {/* set image */}
            <img src={this.props.img} className="m3a1_img" />
          </div>
          <div className="img_share">

            <div className="m3_sh_btm_wrp btn_wrp_position">
              <h4 className="share_txt1">Share to inspire others*</h4>
              <div className="share_btn_img4">
                <img src="/assets/img/img25.jpg" alt="" className="img-fluid" />
                <div className="share_btn_text">
                  <NativeShare
                    sharedata={{
                      image: img,
                      text,
                      postid: id,
                    }}
                  >
                    <button
                      className="btn_sh"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      Share
              </button>

                  </NativeShare>
                </div>
              </div>
              <NavLink to={"/" + urlparams}>
                <h6 className="g_t">
                  Go to Mantra's Home <img src="/assets/img/r_arrow.png" />{" "}
                </h6>
              </NavLink>
            </div>
          </div>
        </div>

        {/* <div
          className="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="s_bx">
              <div className="modal-content share_modal">
                <button
                  type="button"
                  className="close btn_mdl"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <img src="/assets/img/close.png" className="close_modal" />
                </button>
                <div className="m3_sh_img_prev">
                  <span>Thank you for posting!</span>
                </div>
                <h2 className="share_txt_h2">Share...</h2>
                <div className="share_link_txt">
                  <h6>
                    <img src="/assets/img/fb.png" /> Facebook
                  </h6>
                  <h6>
                    <img src="/assets/img/tw.png" /> Twitter
                  </h6>
                  <h6>
                    <img src="/assets/img/insta.png" /> Instagram
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default Mantra_3_A1_Share;
